// extracted by css-extract-rspack-plugin
export default {"panel":"src-shared-components-MainLayout-components-FullPageOnboarding-components-MainScreen-components-ComplianceOverviewRightPanel-ComplianceOverviewRightPanel-module__panel-jl_Yzn","preview":"src-shared-components-MainLayout-components-FullPageOnboarding-components-MainScreen-components-ComplianceOverviewRightPanel-ComplianceOverviewRightPanel-module__preview-k5jpTV","image":"src-shared-components-MainLayout-components-FullPageOnboarding-components-MainScreen-components-ComplianceOverviewRightPanel-ComplianceOverviewRightPanel-module__image-ZT_4Nc"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"panel\":\"src-shared-components-MainLayout-components-FullPageOnboarding-components-MainScreen-components-ComplianceOverviewRightPanel-ComplianceOverviewRightPanel-module__panel-jl_Yzn\",\"preview\":\"src-shared-components-MainLayout-components-FullPageOnboarding-components-MainScreen-components-ComplianceOverviewRightPanel-ComplianceOverviewRightPanel-module__preview-k5jpTV\",\"image\":\"src-shared-components-MainLayout-components-FullPageOnboarding-components-MainScreen-components-ComplianceOverviewRightPanel-ComplianceOverviewRightPanel-module__image-ZT_4Nc\"}";
        // 1793874323169
        var cssReload = require("../../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  